module.exports = __webpack_public_path__ + "static/media/Galleries_01.ed42de30.jpg";